import { QueryCache, QueryClient } from "@tanstack/react-query";
import { captureException } from "@sentry/nextjs";

const queryCache = new QueryCache({
    onError: (err) => {
        captureException(err);
    },
});

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
        mutations: {
            onError: (err) => {
                captureException(err);
            },
        },
    },
    queryCache,
});
